import HttpService from "@/utils/httpData"

export const getlistExercise = classId => {
    let apiEndpoint = `practice/get-practice-type-byclassid?classId=${classId}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data && res.data.data && !res.errors ? res.data.data : null;
    }).catch(e => { return false });
}

export const getBooksByPractice = payload => {
    let apiEndpoint = `practice/get-book-bypractice`;
    return HttpService.post(apiEndpoint, payload).then(res => {
        return res.data && res.data.data && !res.errors ? res.data.data : null;
    }).catch(e => { return false });
}